import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../modules';
import { editContent } from '../../modules/editor';

type Props = {
	selectedContentId: number;
	currentContent: any;
};

function SelectedContentNaverAd({ selectedContentId, currentContent }: Props) {
	const dispatch = useDispatch();
	const editor = useSelector((state: RootState) => state.editor);
	
	const innerContent = currentContent?.content?.content?.[0] || {};
	const contentTarget = `${selectedContentId}/content/0`;

	const handleKeywordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const newKeyword = e.target.value;
		
		// keyword 저장
		dispatch(editContent({ 
			target: `${contentTarget}/adKeyword`, 
			data: newKeyword 
		}));
		
		// URL 업데이트
		const updateUrlWithKeyword = (url: string) => {
			if (!url) return url;
			
			// 기존 keyword 파라미터 제거
			let newUrl = url.replace(/&keyword=[^&]*/, '');
			
			// 새 keyword 추가
			if (newKeyword) {
				const encodedKeyword = encodeURIComponent(newKeyword);
				newUrl = `${newUrl}&keyword=${encodedKeyword}`;
			}
			
			return newUrl;
		};
		
		const newAdImageUrl = updateUrlWithKeyword(innerContent.adImageUrl);
		const newAdLink = updateUrlWithKeyword(innerContent.adLink);
		
		if (newAdImageUrl) {
			dispatch(editContent({ 
				target: `${contentTarget}/adImageUrl`, 
				data: newAdImageUrl 
			}));
		}
		if (newAdLink) {
			dispatch(editContent({ 
				target: `${contentTarget}/adLink`, 
				data: newAdLink 
			}));
		}
	};

	return (
		<div className="editor-sidebar-selected-content-setting">
			<div className="description">
				{/* <h1>
					이렇게 사용하세요.
				</h1>
				<p>
					네이버 광고가 자동으로 표시됩니다.
				</p> */}
			</div>
		</div>
	);
}

export default SelectedContentNaverAd;

